import React from 'react';
import {useTranslation} from 'react-i18next';
import classNames from 'classnames';
import {Badge} from '@taopix/taopix-design-system';

export const AssetUsageBadge = ({id, usage}: {id: string; usage: number}) => {
  const {t} = useTranslation(['helptips']);
  const usageClasses = classNames(
    'bg-pictureUsage',
    'text-pictureUsage',
    'text-[11rem]',
    'text-center',
    'leading-[19rem]',
    'rounded-full',
    'min-w-[18rem]',
    'h-[18rem]',
    'px-xs',
    'outline outline-2 outline-white/50',
    'm-xs'
  );

  return (
    <Badge
      id={id}
      content={usage}
      showToolTip={true}
      toolTipLabel={t('helptips:str_TooltipNumberOfTimesPictureUsed')}
      className={usageClasses}
    />
  );
};
